import FroalaEditor from 'froala-editor';

import {showToastNotification} from 'app/toasts/slice';
import {gt} from 'app/utils/i18n';
import {sendSentryError} from 'app/utils/sentry';

FroalaEditor.PLUGINS.invalidPasteFeedback = function (editor) {
  function afterPaste(content: string) {
    if (content === '') {
      const dispatch = editor.opts.sweetprocess?.reduxDispatch;

      // doesn't error out but let us know Froala wasn't properly configured so we can fix it
      if (dispatch == null) {
        sendSentryError('Froala.invalidPasteFeedback: dispatch is null');
        return;
      }

      dispatch(
        showToastNotification(
          gt(
            'Pasted content was blank. It may be in a format SweetProcess cannot understand.'
          ),
          {level: 'error'}
        )
      );
    }
  }

  return {
    _init: function () {
      editor.events.on('paste.afterCleanup', afterPaste);
    },
  };
};
